export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Automation engineers, industrial technicians, PLC programmers, maintenance professionals, electricians, control systems specialists worldwide.',
  ],
  [
    'Content depth?',
    'From industrial automation fundamentals through advanced PLC systems, control logic, sensors, HMI/SCADA, communication protocols, troubleshooting, and reliability. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal automation and PLC technology principles with guidance for regional electrical codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, 150 technical terms, 48 fault scenarios, 30 practical scenarios, 40 concept connections, 36 safety principles. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
